<template>
    <div class="urgeMessage-list">
        <!-- <div class="tools-bar">
            <div class="tools-search" @keyup.enter="handleSearch">
                <el-input maxlength="100" v-model.trim="searchKeyWord" placeholder="消息模板名称">
                    <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                </el-input>
            </div>
        </div> -->
        <div class="tools-bar head-button">
            <div class="tools-btn-group">
                <el-button icon="el-icon-edit" type="primary" @click="andUrgeMessage">新增催办</el-button>
            </div>
        </div>
        <el-table :data="messageTemplateList" style="width: 100%" v-loading="loading" stripe>
            <el-table-column prop="msgType" label="任务类型" width="260">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.msgType === 0" >流程任务</el-tag>
                    <el-tag type="success" v-if="scope.row.msgType === 1" >审批任务</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="processInstanceName" label="所属流程"></el-table-column>
            <el-table-column prop="taskName" label="流程任务"></el-table-column>
            <el-table-column prop="approvalInstanceName" label="审批任务"></el-table-column>
            <el-table-column prop="receivedUserNames" label="任务负责人"></el-table-column>
            <el-table-column prop="status" label="状态" width="80">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status === 0" >催办中</el-tag>
                    <el-tag type="success" v-if="scope.row.status === 1" >已完成</el-tag>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="remarks" label="备注"></el-table-column>
            <el-table-column fixed="right" label="操作" width="80">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" icon="el-icon-delete" title="删除" circle @click="handleDelete(scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row type="flex" justify="end">
            <el-pagination
                background
                layout="total, prev, pager, next"
                :total="totalPageNum"
                :current-page="currentPage"
                :page-size="pageSize"
                @current-change="queryFormData"
            ></el-pagination>
        </el-row>
        <el-dialog
            title="发起催办消息"
            top="4vh"
            width="55%"
            :visible.sync="isShowAddUrgeMessageForm"
            :key="loadTimer"
            append-to-body
          >
            <el-form ref="urgeMessageForm" size="mini" label-width="120px" class="cronjobNotice-form">
                <el-form-item label="业务类型" style="width: 340px;">
                    <el-radio-group v-model="urgeMessageBO.msgType" @change="msgTypeChange">
                        <el-radio :label="0">流程任务</el-radio>
                        <el-radio :label="1">审批任务</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="urgeMessageBO.msgType===0" label="业务流程">
                    <el-input @focus="chooseProcess" v-model="urgeMessageBO.processInstanceName"></el-input>
                </el-form-item>
                <el-form-item v-if="urgeMessageBO.msgType===0" label="流程任务">
                    <el-select v-model="urgeMessageBO.taskInstanceId" placeholder="请选择要催办的任务" class="triggerSource" @change="selectTaskTrigger">
                        <el-option
                            v-for="item in taskList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="urgeMessageBO.msgType===0" label="负责人">
                    <el-input v-model="urgeMessageBO.receivedUserNames" disabled></el-input>
                </el-form-item>
                <el-form-item v-if="urgeMessageBO.msgType===1" label="审批流">
                    <el-select v-model="urgeMessageBO.approvalInstanceId" placeholder="请选择要催办的审批流" class="triggerSource" @change="selectApprovalTrigger">
                        <el-option
                            v-for="item in approvalInstanceList"
                            :key="item.id"
                            :label="item.approvalName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="urgeMessageBO.msgType===1" label="待审批人">
                    <el-select v-model="urgeMessageBO.receivedUserIds" placeholder="请选择要催办的审批人" class="triggerSource" @change="selectApprovalUserTrigger">
                        <el-option
                            v-for="item in approvalUserList"
                            :key="item.userId"
                            :label="item.trueName"
                            :value="item.userId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="cancelClick">取消</el-button>
                    <el-button type="primary" @click="sendUrgeMessage">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            title="选择流程"
            :visible.sync="isShowProcessListDialog"
            append-to-body
            width = "60%">
            <ProcessPop  :field="{}" ref="processSelect" :formData="{}" @nodeClick="selectTrigger"/>
            <span slot="footer" class="dialog-footer">
                <el-button  type="primary" @click="handleClickOk">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Sidebox from '@/components/Sidebox';
import { getApprovalInstanceUserListById, getApprovalInstanceList, getDoingTaskList, sendUrgeMessage, getUrgeMessageByMeList, delUrgeMessage } from '@/data-model';
import mixinsNav from '@/mixins/mixins-nav';

export default {
    mixins: [mixinsNav],
    components: {
        Sidebox
    },
    data () {
        return {
            loadTimer: '',
            approvalUserList: [],
            searchParams: {
                approvalStatus: 11, // 申请中
                serviceName: '',
                producer: '',
                serviceType: '',
                state: null,
                isOther: false,
                isCopyFlag: 0
            },
            isShowProcessListDialog: false,
            isShowAddUrgeMessageForm: false,
            urgeMessageBO: {
                msgType: 0, // 催办消息类型：0流程、1审批
                processInstanceId: '',
                processInstanceName: '',
                taskInstanceId: '',
                taskName: '',
                approvalInstanceId: '',
                approvalInstanceName: '',
                receivedUserIds: ''
            },
            processList: [],
            taskList: [],
            approvalInstanceList: [],
            messageTemplateList: [], // 列表数据
            currentPage: 1, // 当前页码
            pageSize: 10, // 每页条数
            totalPageNum: 1, // 总页数
            loading: false, // 列表的loading状态
            searchKeyWord: '' // 查询的关键字,
        };
    },
    created () {
        this._initPage();
    },
    methods: {
        async _initPage () {
            await this._getFormData();
        },
        msgTypeChange () {
            this.urgeMessageBO.processInstanceId = '';
            this.urgeMessageBO.processInstanceName = '';
            this.urgeMessageBO.taskInstanceId = '';
            this.urgeMessageBO.taskName = '';
            this.urgeMessageBO.approvalInstanceId = '';
            this.urgeMessageBO.approvalInstanceName = '';
            this.urgeMessageBO.receivedUserIds = '';
            this.urgeMessageBO.receivedUserNames = '';
            this.approvalUserList = [];
            this.taskList = [];
            if (this.urgeMessageBO.msgType === 1) {
                this.getApprovalInstanceList();
            }
        },
        async getApprovalInstanceList () {
            this.loading = true;
            let formData = await getApprovalInstanceList(Object.assign({}, {
                currentPage: 1,
                pageSize: 1000
            }, this.searchParams));
            if (formData) {
                this.approvalInstanceList = formData.data;
            }
            this.loading = false;
        },
        async _getFormData () {
            this.loading = true;
            let formData = await getUrgeMessageByMeList(this.currentPage, this.pageSize, this.searchKeyWord);
            this.messageTemplateList = formData.data;
            this.currentPage = formData.currentPage;
            this.pageSize = formData.pageSize;
            this.totalPageNum = formData.totalPageNum;
            this.loading = false;
        },
        queryFormData (currentPage) {
            this.currentPage = currentPage;
            this._getFormData();
        },
        handleSearch () {
            this.currentPage = 1;
            this._getFormData();
        },
        handleDelete (row) {
            this.$confirm(`您确定要删除吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                await delUrgeMessage(row);
                await this.handleSearch();
            }).catch(() => {});
        },
        chooseProcess () {
            this.isShowProcessListDialog = true;
        },
        selectTrigger (selected) { // 选择流程
            this.urgeMessageBO.processInstanceId = selected.id;
            this.urgeMessageBO.processInstanceName = selected.label;
        },
        async handleClickOk () {
            this.isShowProcessListDialog = false;
            this.urgeMessageBO.taskInstanceId = '';
            this.urgeMessageBO.taskName = '';
            this.urgeMessageBO.receivedUserIds = '';
            this.urgeMessageBO.receivedUserNames = '';
            this.getDoingTaskList();
        },
        async getDoingTaskList () {
            this.taskList = await getDoingTaskList({processInstanceId: this.urgeMessageBO.processInstanceId});
        },
        selectTaskTrigger () {
            for (let i = 0; i < this.taskList.length; i++) {
                let obj = this.taskList[i];
                if (obj.id === this.urgeMessageBO.taskInstanceId) {
                    this.urgeMessageBO.taskName = obj.name;
                    this.urgeMessageBO.receivedUserIds = obj.assigneeUserId;
                    this.urgeMessageBO.receivedUserNames = obj.assigneeTrueName;
                    break;
                }
            }
        },
        andUrgeMessage () {
            this.loadTimer = new Date().getTime();
            this.isShowAddUrgeMessageForm = true;
        },
        async sendUrgeMessage () {
            this.$confirm('您确定要给当前任务负责人【' + this.urgeMessageBO.receivedUserNames + '】发送催办消息吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await sendUrgeMessage(this.urgeMessageBO);
                await this.handleSearch();
                loading.close();
                this.isShowAddUrgeMessageForm = false;
            }).catch(() => {
                this.isShowAddUrgeMessageForm = false;
            });
        },
        cancelClick () {
            this.isShowAddUrgeMessageForm = false;
        },
        async selectApprovalTrigger () {
            for (let i = 0; i < this.approvalInstanceList.length; i++) {
                let obj = this.approvalInstanceList[i];
                if (obj.id === this.urgeMessageBO.approvalInstanceId) {
                    this.urgeMessageBO.approvalInstanceName = obj.approvalName;
                    break;
                }
            }
            this.urgeMessageBO.receivedUserIds = '';
            this.urgeMessageBO.receivedUserNames = '';
            this.approvalUserList = await getApprovalInstanceUserListById({approvalInstanceId: this.urgeMessageBO.approvalInstanceId});
        },
        async selectApprovalUserTrigger () {
            for (let i = 0; i < this.approvalUserList.length; i++) {
                let obj = this.approvalUserList[i];
                if (obj.userId === this.urgeMessageBO.receivedUserIds) {
                    this.urgeMessageBO.receivedUserNames = obj.trueName;
                    break;
                }
            }
        }
    }
};
</script>

<style lang="less" scoped="scoped">
.urgeMessage-list {
    height: 100%;
    width: 100%;
    .tools-bar {
        height: 4vh;
        line-height: 4vh;
        margin-top: 3vh;
        // width: 100%;
    }
    .head-button {
        float: right;
        margin-top: -10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/UrgeMessage/UrgeMessageList.vue